module.exports = __webpack_public_path__ + "static/media/icon-eye.b2682600.svg";